<section fxLayout="column" fxLayoutAlign="space-around center">
    <mat-form-field [formGroup]="emailForm" appearance="outline">
        <mat-label>{{ 'contact.email' | transloco }}</mat-label>
        <input matInput type="email" formControlName="email">
    </mat-form-field>
    <mat-form-field appearance="outline" [formGroup]="emailForm">
        <mat-label>{{ 'contact.message' | transloco }}</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMaxRows="10"
            autocomplete="off" cdkAutosizeMinRows="5" formControlName="message"></textarea>
    </mat-form-field>
    <button mat-raised-button (click)="sendEmail()" color="primary" [disabled]="emailForm.invalid">{{ 'contact.send' | transloco }}</button>
</section>